import React from "react";
function formatDate(inputDate) {
  const date = new Date(inputDate); // Convert the input to a Date object

  // Define month names
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Extract date, month, and year
  const day = date.getUTCDate(); // Get the day of the month
  const month = months[date.getUTCMonth()]; // Get the month name
  const year = date.getUTCFullYear(); // Get the year

  // Return formatted string
  return `${day} ${month} ${year}`;
}
export default function ViewStockLayer({ data }) {
  return (
    <div className="card basic-data-table">
  
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 row">
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
               Title
              </label>
              <p id="label_1">{data.title}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Sell Price
              </label>
              <p id="label_1">{data.sellPrice}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Cost Price
              </label>
              <p id="label_1">{data.costPrice}</p>
            </div>
            <div className="col-md-6 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Quantity
              </label>
              <p id="label_1">{data.quantity}</p>
            </div>
            
            <div className="col-md-12 mb-20">
              <label
                htmlFor="label_1"
                className="form-label fw-semibold text-primary-light text-sm mb-8"
              >
                Descripiton
              </label>
              <div dangerouslySetInnerHTML={{__html: data.description}}/>
            </div>
            
           
          
           
          </div>
        </div>
      
      </div>
    </div>
  );
}
